// extracted by mini-css-extract-plugin
export default {"inputBox":"Input_inputBox__0O4BE","redStar":"Input_redStar__-pttd"};